exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".task-label {\n  line-height: 32px;\n}\n", ""]);

// exports
